if (!customElements.get('partner-application')) {
  customElements.define('partner-application', class extends HTMLElement {
    connectedCallback() {
      this.observer?.disconnect();
      const hero = document.querySelector('[data-partner-hero]');
      const application = this.querySelector('[data-partner-application]');
      const sticky = this.querySelector('[data-partner-sticky]');
      if (!hero || !application || !sticky) return;
      const update = () => {
        const hide = hero.getBoundingClientRect().bottom > 0 || application.getBoundingClientRect().top <= window.innerHeight;
        if (hide && sticky.contains(document.activeElement)) application.querySelector('h2').focus({ preventScroll: true });
        sticky.hidden = hide;
        document.body.style.setProperty('--partner-sticky-height', hide ? '0px' : `${sticky.getBoundingClientRect().height}px`);
      };
      this.observer = new IntersectionObserver(update);
      this.observer.observe(hero);
      this.observer.observe(application);
      update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      document.body.style.removeProperty('--partner-sticky-height');
    }
  });
}
